/**
 * Los tipos propios de la pantalla de digitación. Lo que viene del API está
 * en `api/contract.ts`; aquí solo lo que la pantalla decide por su cuenta.
 */

/**
 * Las dos secciones del documento que el digitador revisa: los datos de la
 * factura (número y fecha) y el detalle (sus líneas, con el campo «¿Hay
 * producto ADELCA?»). El emisor no es una de ellas: el digitador no lo ve.
 */
export const SECTIONS = ["documentData", "detail"] as const;

export type SectionKey = (typeof SECTIONS)[number];

/** El color de cada tipo de dato. */
export const COLOR_KINDS = ["number", "date"] as const;

export type ColorKind = (typeof COLOR_KINDS)[number];

/**
 * Las tres decisiones, en el orden de sus números: Válida, Inválida y Para
 * información (`for_data` en el API).
 */
export const DECISION_KINDS = ["valid", "invalid", "forData"] as const;

export type DecisionKind = (typeof DECISION_KINDS)[number];

export type Decision =
  | {
      readonly kind: "valid";
      /** El grupo elegido en un documento 100 % manual (`productGroupId`). */
      readonly productGroupId?: number;
    }
  | {
      readonly kind: "invalid";
      readonly reasonKey: string | null;
      /** Lo que se escribió, para un motivo que pide nota («Otro motivo»). */
      readonly note?: string;
      /** «Duplicada de…»: la original elegida, si se elige una. */
      readonly duplicateOf?: string;
    }
  | { readonly kind: "forData" };

/**
 * La decisión ya guardada (`item.decision.outcome`), para marcarla en la
 * barra aunque esté deshabilitada (§C): no trae el motivo, así que el botón
 * «Inválida» se ve elegido sin reason. `null` si el outcome no es una
 * decisión de un digitador.
 */
export const decisionOfOutcome = (outcome: string): Decision | null => {
  switch (outcome) {
    case "valid":
      return { kind: "valid" };
    case "invalid":
      return { kind: "invalid", reasonKey: null };
    case "for_data":
      return { kind: "forData" };
    default:
      return null;
  }
};
